module.exports = __webpack_public_path__ + "static/media/thumbnail.b43e9e17.jpg";